module.exports = __webpack_public_path__ + "img/login-logo.664d6085.png";